module.exports = __webpack_public_path__ + "static/img/release_title2.e01c935.png";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/images/release/release_title2.png
// module id = heaC
// module chunks = 0